module.exports = "/_next/static/videos/softball-3-374ac9c4019891ac92625313e9e9e152.webm";